import { STOREFRONT_RESERVED_SEGMENTS } from '@/common/constants/top-message-bar.constant';
import type { ShopperTopMessageBar } from '@/common/types/vendor.type';

export function resolveStorefrontVendorSlug(
  pathname: string,
  isTenant: boolean
): string | null {
  if (isTenant) {
    return '';
  }

  const firstSegment = pathname.split('/').filter(Boolean)[0];
  if (!firstSegment || STOREFRONT_RESERVED_SEGMENTS.has(firstSegment)) {
    return null;
  }

  return firstSegment;
}

export function isVisibleTopMessageBar(
  configuration?: ShopperTopMessageBar | null
): configuration is ShopperTopMessageBar {
  return Boolean(configuration?.isVisible && configuration.message);
}
